import type { TurnstileInstance } from "@marsidev/react-turnstile";
import { Turnstile } from "@marsidev/react-turnstile";
import type { Dispatch } from "react";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

import type { TurnstileActionType } from "../hooks/useTurnstile";

interface TurnstileWrapperProps {
  dispatch: Dispatch<{ type: TurnstileActionType }>;
  shouldShowTurnstile: boolean;
  siteKey?: string;
  turnstileRef: React.RefObject<TurnstileInstance | null>;
}

export const TurnstileWrapper = ({
  turnstileRef,
  shouldShowTurnstile,
  dispatch,
  siteKey = window.TURNSTILE_CAPTCHA_SITE_KEY || "",
}: TurnstileWrapperProps) => {
  const toast = useToast();

  return (
    <Turnstile
      ref={turnstileRef}
      options={{ theme: "light" }}
      className={shouldShowTurnstile ? "" : "hidden"}
      onError={() => {
        dispatch({ type: "SET_FAILED" });
        const message = t("authentication_app.create_community.errors.failed");
        toast.error(message);
      }}
      onExpire={() => dispatch({ type: "SET_FAILED" })}
      onSuccess={() => dispatch({ type: "SET_SUCCESS" })}
      onBeforeInteractive={() => dispatch({ type: "SET_INTERACTIVE" })}
      siteKey={siteKey}
    />
  );
};
